<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Reporte de Créditos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <span class="title">Filtros</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="listEmpresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Créditos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.canalVentaId"
              :items="listCanalesVenta"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="del Canal de Venta"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col>
            <v-select
              :items="listSubEstados"
              v-model="filtro.subEstadoCreditoIds"
              item-text="descripcion"
              item-value="id"
              label="en Estado"
              multiple>
              <!-- ABAJO esto es para agregar la opción de select all -->
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleSubEstados">
                  <v-list-item-action>
                    <v-icon
                      :color="
                        filtro.subEstadoCreditoIds.length > 0
                          ? 'indigo darken-4'
                          : ''
                      "
                      >{{ iconSubEstados }}</v-icon
                    >
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Marcar todos</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <!-- ARRIBA esto es para agregar la opción de select all -->
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.descripcion }}</span>

                <span v-if="index === 1" class="grey--text caption"
                  >&nbsp;(+ {{ filtro.subEstadoCreditoIds.length - 1 }} estados
                  más)</span
                >
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaDesde"
              label="Ingresados Desde"
              type="date"
              prepend-icon="event"></v-text-field>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaHasta"
              label="Ingresados Hasta"
              type="date"
              prepend-icon="event"></v-text-field>
          </v-col>
        </v-row>

        <v-row dense> </v-row>
        <!-- 
                <span class="title" >Opciones</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="10" lg="6">
                        <v-radio-group v-model="filtro.agrupamiento" :mandatory="true" label="Agrupar por" row>
                            <v-radio value="0">
                                <div slot="label">Producto/Plan</div>
                            </v-radio>
                            <v-radio value="1">
                                <div slot="label">Tipo Cliente/Producto/Plan</div>
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6" lg="3">
                        <v-switch v-model="filtro.resumido" label="Resumido"></v-switch>
                    </v-col>                    
                </v-row> -->
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn dark  color="green" @click="procesarBase">
                    Descargar Archivo&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn> -->
        <v-spacer></v-spacer>
        <v-btn dark color="green" @click="procesarReporte">
          Generar Reporte&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 1,
        sucursalId: 0,
        canalVentaId: 0,
        subEstadoCreditoId: 0,
        subEstadoCreditoIds: [],
        fechaDesde: null,
        fechaHasta: null,
      },
      listEmpresas: [],
      listSucursales: [],
      listCanalesVenta: [],
      listSubEstados: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadSucursales();
    this.loadCanalesVenta();
    this.loadSubEstados();

    this.filtro.fechaDesde = this.$moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.filtro.fechaHasta = this.$moment(new Date()).format("YYYY-MM-DD");
  },
  computed: {
    ...mapGetters([
      "activeTask",
      "getActionFromLink",
      "user",
      "closeRelatedTasks",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    todosLosSubEstados() {
      return (
        this.filtro.subEstadoCreditoIds.length === this.listSubEstados.length
      );
    },
    algunosSubEstados() {
      return (
        this.filtro.subEstadoCreditoIds.length > 0 && !this.todosLosSubEstados
      );
    },
    iconSubEstados() {
      if (this.todosLosSubEstados) return "mdi-close-box";
      if (this.algunosSubEstados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    toggleSubEstados() {
      this.$nextTick(() => {
        if (this.todosLosSubEstados) {
          this.filtro.subEstadoCreditoIds = [];
        } else {
          this.filtro.subEstadoCreditoIds = this.listSubEstados.map(function (
            p
          ) {
            return p.id;
          });
        }
      });
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/porusuario?usuarioId=" + this.user.id
        );

        this.listEmpresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          "sucursales/list/porusuario?usuarioId=" + this.user.id
        );

        this.listSucursales = result.list;

        this.listSucursales.unshift({ id: 0, nombre: "(Todas)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          "canalesventa/habilitadosparausuario?usuarioId=" + this.user.id
        );

        this.listCanalesVenta = result.list;
        this.listCanalesVenta.unshift({ id: 0, nombre: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSubEstados() {
      this.loading = true;
      try {
        var result = await http.get("tipossubestadocredito/");

        this.listSubEstados = result.list;
        // this.listSubEstados.unshift({id:0,descripcion:'(Cualquiera)'});
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validar() {
      if (this.filtro.empresaId === 0) {
        this.alertWarning("Debe seleccionar una Empresa.");
        return false;
      }

      if (!this.filtro.fechaDesde) {
        this.alertWarning("Debe ingresar la Fecha de Ingreso Desde.");
        return false;
      }

      if (!this.filtro.fechaHasta) {
        this.alertWarning("Debe ingresar la Fecha de Ingreso Hasta.");
        return false;
      }

      return true;
    },
    async procesarReporte() {
      // validaciones
      if (!this.validar()) {
        return;
      }

      var self = this;

      try {
        self.loading = true;

        let params = [];
        params.push({
          Version: this.$store.state.version,
          CanalesVentaId: this.filtro.canalVentaId,
          CreditosSubEstadoId: this.filtro.subEstadoCreditoIds,
          EmpresaId: this.filtro.empresaId,
          IngresoDesde: this.filtro.fechaDesde,
          IngresoHasta: this.filtro.fechaHasta,
        });

        this.setReporteActivo({
          reporte: "Creditos Detallado.trdp",
          params: params,
        });
        window.open("/report-viewer");
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>
